import React from 'react';
import { useTranslation } from 'react-i18next';
import { CookieBanner, cookieBannerLabels, cookiePolicyUrl } from '@easydent/shared-ui';

/**
 * The shared cookie banner, in the language the rest of the portal is using.
 *
 * `useSuspense: false` is deliberate — see the note in clinic-app's copy: translations load over
 * HTTP and the banner renders outside the Suspense boundary, so it must never suspend.
 *
 * The policy link is explicit because this app has no `/legal/:slug` route — the banner's default
 * relative href was a 404, on the one link a visitor follows precisely because they want to read
 * before agreeing. clinic-app serves that page itself and keeps the default.
 */
const AppCookieBanner: React.FC = () => {
  const { t } = useTranslation('common', { useSuspense: false });
  return <CookieBanner labels={cookieBannerLabels(t)} cookiePolicyHref={cookiePolicyUrl()} />;
};

export default AppCookieBanner;
